import { TEXT_OVERFLOW_MIXIN } from 'src/shared/constants/styling-constants'
import styled from 'styled-components'

export const TextOverflowSpanStyled = styled.span<{ $withTooltip?: boolean }>`
  max-width: ${({ $withTooltip }) => ($withTooltip ? 'calc(100% - 1.75rem)' : '100%')};
  ${TEXT_OVERFLOW_MIXIN};
`
